import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import { fciFetch } from "@/shared/lib/fci";
import type { TransformedTreesResponse, TreesResponse } from "./types";

const transformTreesResponse = (response: TreesResponse): TransformedTreesResponse => {
    const trees = response.AllTrees.map((tree) => ({ id: tree.TreeId, name: tree.Name }));
    const selectedTree = response.SelectedTree || (response.AllTrees.length > 0 ? response.AllTrees[0] : null);

    return {
        trees,
        selectedTree: selectedTree ? { id: selectedTree.TreeId, name: selectedTree.Name } : null,
    };
};

export const getTrees = async () => {
    const treesResponse = await fciFetch<TreesResponse>(
        `/api/person-picker/trees?timestamp=${new Date().getTime()}&rights=all`,
        {
            fci: {
                // Powers person-picker suggestions and quick-fill
                // If it fails, the user can still fill in the form manually
                errorType: FCI_ERROR.Convenience,
                errorInfo: "getTrees",
            },
        },
    );

    return transformTreesResponse(treesResponse);
};
